export default "__VITE_ASSET__XSqzvQ08__"